import { render, staticRenderFns } from "./PgaEntityStatus.vue?vue&type=template&id=e1471ac2&scoped=true&"
import script from "./PgaEntityStatus.vue?vue&type=script&lang=ts&"
export * from "./PgaEntityStatus.vue?vue&type=script&lang=ts&"
import style0 from "./PgaEntityStatus.vue?vue&type=style&index=0&id=e1471ac2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1471ac2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1471ac2')) {
      api.createRecord('e1471ac2', component.options)
    } else {
      api.reload('e1471ac2', component.options)
    }
    module.hot.accept("./PgaEntityStatus.vue?vue&type=template&id=e1471ac2&scoped=true&", function () {
      api.rerender('e1471ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaEntityStatus.vue"
export default component.exports